export const centsToDollarDisplay = (value, showDollarSign, hideDecimalsIfNoCents) => {
  if (value !== 0 && !value) return '';
  let display = value / 100;
  if (value % 100 !== 0 || (value % 100 === 0 && !hideDecimalsIfNoCents)) {
    display = (value / 100).toFixed(2);
  }
  return showDollarSign ? `$${display}` : display;
};
